import moment from "moment";

export type CourseType = "VKU" | "PGS" | "FirstAid" | "DrivingAttendant" | "MotorcycleTraining";

class CourseService {
  getFirstPartDate(addedCourses: any[]) {
    const firstCourse = addedCourses.find(x => x.part === 1);

    let firstCourseDate: Date | undefined;
    if (firstCourse) {
      firstCourseDate = moment.utc(firstCourse.dateRange1.start1, 'YYYY-MM-DD HH:mm').toDate();
    }

    return firstCourseDate;
  }

  mapUrlTypeToType(urlType: string): CourseType {
    if (urlType === "nothelfer") return "FirstAid";
    else if (urlType === "pgs") return "PGS";
    else if (urlType === "vku") return "VKU";
    else if (urlType === "motorrad-weiterbildungskurs") return "MotorcycleTraining";
    else if (urlType === "fahrbegleiterkurs") return "DrivingAttendant";
  }
}

export default new CourseService();